const SiteTexts = (username?: string) => {
  const Texts = {
    GENERAL: {
      CHANGE_PASSWORD: "Change Password",
    },
    PANEL: {
      PROGRESS_BOX_TITLE: "Progress Box",
      LAST_APPROVED_PROPERTIES: "Last Approved Properties",
    },
    REQUEST_PAGES: {
      AGENT_REQUEST: "Agent Request",
      RENTAL_REQUEST: "Rental Request",
      SUBMITED_PROPERTY: "Submited Property",
    },
    LOGIN: {
      LOGIN_TITLE: "SIGN IN TO DELTA HOME",
      FORGET_YOUR_PASSWORD: "Forgot your password?",
    },
    PROPERTY_LIST: {
      REFINE_YOUR_SEARCH: "Refine Your Search",
      LIST_PROPERTIES: "List Properties",
    },
    LIST_AGENT: {
      AGENT_LIST: "Agent List",
    },
    ADD_AGENT: {
      ADD_AGENT: "Add Agent",
    },
    EDIT_AGENT: {
      EDIT_AGENT: "Edit Agent",
    },
    REGION_SORT:{
      TITLE:'Region sort'
    },
    ADD_PROPERTY: {
      PROPERTY_STATUS: "Property Status",
      ADD_PROPERTY: "Add Property",
      AGENCY_DETAILS: "Agency Details",
      OWNER_DETAILS: "Owner Details",
      REGION_DETAILS: "Region Details",
      DETAILS: "Details",
      PEYMENT_DETAILS: "Payment Details",
      MAIN_FEATURES: "Main Features",
      Additional_Features: "Additional Features",
      SeoInformation: "SEO Information",
      Location: "Location",
      EDIT_PROPERTY: "Edit Property",
      IMAGES: "Images",
      IMAGE_INSTRUCTIONS : [
        'You can attach 30 photo for each listing.',
      ]
    },
    BASE_INFO: {
      TITLE: "Base Info",
      DESCRIPTION: "Add New Items and Edit existing Items.",
    },
    ABOUT_US: {
      TITLE: "AboutUs",
    },
  };

  return Texts;
};

export default SiteTexts;
